// extracted by css-extract-rspack-plugin
export default {"cls1":"SuggestedContentSidebar-cls1_eMG","cls2":"SuggestedContentSidebar-cls2_uIW SuggestedContentSidebar-cls1_eMG"};